import ContractBaseController from '../common/contract.base.controller'

class ContractallController extends ContractBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, ContractService, $translate, $stateParams, $scope, $location, DataCounter, Navigation) {

    super(Auth, $state, User, ContractService, Modal, $translate, $stateParams, $location)

    this.id = 'contract.all'
    this.loading = true
    this.contracts = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this.searchText = '';
    this._status = 'active';
    this.$location = $location;
    this.DataCounter = DataCounter;
    this.Navigation = Navigation;
    this.branchId = this.User.getUser().branchId;
    this.uncoveredOnCallLocationCount = null;
    this.uncoveredOnCallLocationCountLoading = false;
    this.uncoveredOnCallLocationCountError = '';

    this.contractStatus = [
      {
        label: $translate.instant('location_types.All'),
        value: null,
      },
      {
        label: $translate.instant('common.active'),
        value: 'active'
      },
      {
        label: $translate.instant('common.inactive'),
        value: 'inactive'
      }]

    this.customerHistoryObj = {
      totalRecords: 0,
      results: [],
      loading: false,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      allowOnlyOnce: false,
      errorMessage: '',
      searchText: '',
      history: {},
      extraDetails: {},
    };

    this.sortColumn = '';
    this.reverseSort = true;
    this.currentStats = {};

    this.contractHistoryStats = {
      customers: 'customers'
    }
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
    this.loadUncoveredOnCallLocationCount()
  }

  loadUncoveredOnCallLocationCount() {
    this.uncoveredOnCallLocationCountLoading = true;
    this.uncoveredOnCallLocationCountError = '';

    this.Service.getUncoveredOnCallLocations(undefined, undefined, true)
      .then((data) => {
        this.uncoveredOnCallLocationCount = data.totalRecords;
      })
      .catch((err) => {
        this.uncoveredOnCallLocationCountError = err && err.data && err.data.message ? err.data.message : err.message;
      })
      .finally(() => {
        this.uncoveredOnCallLocationCountLoading = false;
      });
  }

  showUncoveredOnCallLocations() {
    this.Modal.uncoveredLocations();
  }

  edit(contract) {
    this.$state.go('contract.edit', ({
      id: contract.id
    }))
  }

  delete(contract) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${contract.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(contract.id, this.branchId)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
    this.loadUncoveredOnCallLocationCount()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  // generateSearchObj() {
  //   return {
  //     queryText: '%' + this.searchObj + '%',
  //     isQuery: false
  //   };
  // }

  generateSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            group: {
              rules: [
                {
                  field: 'id',
                  condition: 'like',
                  data: `%${this.searchText}%`
                },
                {
                  field: 'contractName',
                  condition: 'like',
                  data: `%${this.searchText}%`
                },
                {
                  field: 'billingIncrement',
                  condition: 'like',
                  data: `%${this.searchText}%`
                },
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };

    switch (this._status) {
      case 'active': {
        searchObj.queryJSON.rules.push({
          field: 'status',
          condition: '=',
          data: true
        });
        break;
      }
      case 'inactive': {
        searchObj.queryJSON.rules.push({
          field: 'status',
          condition: '=',
          data: false
        });
        break;
      }
    }
    return searchObj;
  }

  loadData() {
    const searchObj = this.generateSearchObj()

    this.loading = true;
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total
        this.loading = false
        this.contracts = data.results;
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  toggleExpand(contract) {
    contract.expand = !contract.expand;
    this.currentStats[contract.id] = this.contractHistoryStats.customers;
  }

  getCurrentStats(obj, value) {
    if (!obj.expanded) return;
    this.currentStats[obj.id] = value;
  }

  // ------------------------------------------ Customer history logic section start ------------------------------------------ //

  setCustomerHistoryPage(isExpanded, customerId) {
    if (!isExpanded) return;
    this.customerHistoryObj.extraDetails[customerId] = { page: 1 };
  }

  getCustomerHistory(data, event) {
    const customerId = data.id;

    document.getElementById(`expand-btn-${customerId}`).blur();
    if (!data.expanded) return;

    this.customerHistoryObj.history[customerId] = { process: true };

    this.Service.getCustomerHistory(this.customerHistoryObj.extraDetails[customerId].searchText, customerId, this.reverseSort, this.sortColumn,
      (this.customerHistoryObj.extraDetails[customerId].page - 1) * this.customerHistoryObj.pagination.pageLimit,
      this.customerHistoryObj.pagination.pageLimit)
      .then((history) => {
        this.customerHistoryObj.history[customerId].details = history;
        this.customerHistoryObj.history[customerId].details.pageLimit = this.customerHistoryObj.pagination.pageLimit;
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.customerHistoryObj.history[customerId].process = false;
      })
  }

  sortData(column, obj, event) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
    this.loadCustomerHistory(obj, event);
  }

  goToLocationTab(customerObj) {
    const obj = {
      customerId: customerObj.customerId,
      isRedirected: true
    };

    this.DataCounter.setData(obj);
    this.Navigation.goToAllLocationTab();
  }

  goToCustomerTab(customerObj) {
    this.$state.go('customer.edit', ({
      id: customerObj.customerId
    }))
  }

  searchCustomerHistory(data, event) {
    this.customerHistoryObj.extraDetails[data.id].page = 1;
    this.getCustomerHistory(data, event);
  }

  customerHistoryFn(obj, event) {
    this.resetSearchText(obj);
    this.getCurrentStats(obj, this.contractHistoryStats.customers);
    this.setCustomerHistoryPage(obj.expanded, obj.id);
    this.loadCustomerHistory(obj, event);
  }

  resetSearchText(obj) {
    const contractId = obj.id;
    this.customerHistoryObj.extraDetails[contractId] = { searchText: '' };
    this.customerHistoryObj.extraDetails[contractId].searchText = '';
  }

  loadCustomerHistory(obj, event) {
    if (this.currentStats[obj.id] === this.contractHistoryStats.customers) this.getCustomerHistory(obj, event);
  }

  // ------------------------------------------ Customer history logic section end ------------------------------------------ //
  
}

export default ContractallController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/all/contract.all.controller.js